type ExtraData = Record<string, unknown>

const isAdmin = window.location.pathname.match(/^\/admin\//)
export const TRACKING_URL = isAdmin ? '/admin/trackings' : '/trackings'

export interface TrackOptions {
  keyword?: string
  keywords?: string[]
  multi?: boolean
  element?: HTMLElement | null
  extra_data?: ExtraData
}

/**
 * トラッキングリクエストを送信
 */
export function track(
  keywordOrKeywords: string | string[],
  multi: boolean = false,
  element?: HTMLElement | null,
  extra_data?: ExtraData
): Promise<Response> {
  const data = multi
    ? { keywords: keywordOrKeywords, extra_data }
    : { keyword: keywordOrKeywords, extra_data }

  // elementが指定されている場合、完了時にカスタムイベントを発火
  const fetchPromise = fetch(TRACKING_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(data),
    credentials: 'same-origin',
  })

  if (element) {
    void fetchPromise.finally(() => {
      const event = new CustomEvent('bargainTracked')
      element.dispatchEvent(event)
    })
  }

  return fetchPromise
}

/**
 * extra_data付きのトラッキング
 */
export function trackWithExtra(
  keywordOrKeywords: string | string[],
  extra_data?: ExtraData,
  multi: boolean = false,
  element?: HTMLElement | null
) {
  return track(keywordOrKeywords, multi, element, extra_data)
}
